// Variant option carousels (Swiper). Moved out of snippets/variant-main-picker.liquid
// so it loads with `defer` instead of blocking the parser. Runs on DOMContentLoaded
// (which fires after deferred scripts, so window.Swiper from swiper-bundle.min.js is
// available) and re-syncs on `variant:update`.

// Initialize Swiper instances
function initializeVariantSwipers() {
  if (window.Swiper) {
    const swiperElements = document.querySelectorAll('.variant-swiper');
    swiperElements.forEach((swiperElement) => {
      // Destroy existing instance if it exists
      if (swiperElement.swiper && typeof swiperElement.swiper.destroy === 'function') {
        swiperElement.swiper.destroy(true, true);
      }

      // Get the option type from the class (e.g., variant-swiper-color, variant-swiper-size)
      const optionClass = Array.from(swiperElement.classList).find(cls => cls.startsWith('variant-swiper-'));
      const optionType = optionClass ? optionClass.replace('variant-swiper-', '') : '';

      // Use default gap for all variant types
      let spaceBetween = 10; // default gap

      // Find the initial slide index
      const activeSlide = swiperElement.querySelector('.swiper-slide input:checked');
      let initialSlideIndex = 0;
      if (activeSlide) {
        const slides = swiperElement.querySelectorAll('.swiper-slide');
        initialSlideIndex = Array.from(slides).findIndex(slide =>
          slide.contains(activeSlide)
        );
        if (initialSlideIndex === -1) initialSlideIndex = 0;
      }
      // For size options, always start at the first (smallest) slide
      if (optionType === 'size') {
        initialSlideIndex = 0;
      }

      // Create new instance with unique navigation buttons
      const swiper = new Swiper(swiperElement, {
        slidesPerView: 'auto',
        spaceBetween: spaceBetween,
        freeMode: true,
        grabCursor: true,
        slideToClickedSlide: true,
        centeredSlides: false,
        initialSlide: initialSlideIndex,
        navigation: {
          nextEl: `.swiper-button-next-${optionType}`,
          prevEl: `.swiper-button-prev-${optionType}`,
        },
        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },
      });
    });
  }
}

// Initialize on DOM load
document.addEventListener('DOMContentLoaded', initializeVariantSwipers);

// Handle variant updates with smooth sliding
document.addEventListener('variant:update', (event) => {
  // Small delay to ensure DOM has been updated
  setTimeout(() => {
    const swiperElements = document.querySelectorAll('.variant-swiper');
    swiperElements.forEach((swiperElement) => {
      if (swiperElement.swiper) {
        // Find the new active variant
        const activeSlide = swiperElement.querySelector('.swiper-slide input:checked');
        if (activeSlide) {
          const slideIndex = Array.from(swiperElement.swiper.slides).findIndex(slide =>
            slide.contains(activeSlide)
          );
          if (slideIndex !== -1 && slideIndex !== swiperElement.swiper.activeIndex) {
            // Smoothly slide to the new active variant
            swiperElement.swiper.slideTo(slideIndex, 300);
          }
        }
      }
    });
  }, 100);
});
